(ns rothko.editor.space.component
  (:require [clojure.string :as str]))

(defn token
  [{:keys [corrected-view?] {:keys [word type edited? tagged? ignored? system? different? suspicious?]} :token}]
  [:span.editor__space
   {:class (cond-> #{}
             (or edited? tagged?) (conj :edited)
             ignored? (conj :ignored)
             (and (= type :space-edit) (not corrected-view?)) (conj :as-edit)
             (and edited? system?) (conj :system-annotation)
             different? (conj :different)
             (and suspicious?
                  (not (and edited? system?))) (conj :suspicious))}
   (cond-> word
     edited? (some-> (str/replace "\n" "⏎")))])
